import React from "react";
import UserManagementScreen from "./UserManagementScreen";

export default function UserManagement() {
  return <UserManagementScreen />;
}
